<template>
  <div class="page-change-phone">
    <h2>{{$t('setting.changePhone.title')}}</h2>
    <el-tabs v-model="activeName"
             @tab-click="selectVerifyType">
      <el-tab-pane :label="$t('setting.byPhone')"
                   name="phone"
                   test_id= "change_phone_verifyByPhone">
        <h4 v-show="h4Show">{{$t('setting.changePhone.phoneTitle')}} {{params.changePhoneNumShow}}</h4>
        <div v-show="subWrapShow"
             class="sub-wrap">
          <h4>{{$t('setting.changePhone.subtitle')}}</h4>
        </div>
      </el-tab-pane>
      <el-tab-pane label="邮箱验证"
                   name="email"
                   test_id= "change_phone_verifyByEmail">
        <div class="tip">
          <span v-show="!newPhoneShow"
                v-html="oldTip"></span>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-form :model="form"
             :rules="rules"
             ref="form"
             class="form-change-phone"
             :label-position="labelPosition">
      <el-form-item v-show="newPhoneShow"
                    class="new-phone"
                    prop="newPhone"
                    :label-width="formLabelWidth">
        <el-input :disabled="isEnter"
                  test_id="input_new_phone"
                  v-model="form.newPhone"
                  :placeholder="$t('setting.changePhone.phoneNumPlaceholder')"
                  autocomplete="off">
          <template slot="prepend">+86</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="verCode"
                    :label-width="formLabelWidth">
        <el-input v-model="form.verCode"
                  test_id="input_verification_code"
                  :placeholder="$t('setting.changePhone.verCodePlaceholder')"
                  autocomplete="off">
          <span :style="countStyle"
                @click="getVerificationCode"
                test_id="get_verification_code"
                class="append-text"
                slot="suffix">
            <span>{{ToolTip}}</span>
          </span>
        </el-input>
      </el-form-item>
    </el-form>
    <div class="footer-wrap">
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   test_id="button_submit_changephone"
                   class="submit-button"
                   :loading="loading"
                   @click="submitForm('form')">{{$t('setting.setPassword.submit')}}</el-button>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   class="cancel-button"
                   test_id="button_cancel_changephone"
                   :disabled="cancel"
                   @click="resetForm('form')">{{$t('setting.setPassword.cancel')}}</el-button>
      </div>
    </div>

  </div>

</template>
<script>
import SecurityService from '@/js/util/SecurityService.js'
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
export default {
  props: ['params'],
  // 增加密码规则：必须为数字和字母组合，长度6-16
  data () {
    var checkVerCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('setting.changePhone.codeInput')))
      } else {
        callback()
      }
    }
    var checkNewPhone = (rule, value, callback) => {
      if (this.newPhoneShow) {
        let patrn = /^1[3|4|5|7|8][0-9]\d{4,8}$/
        console.log(this.form.area)
        if (this.form.area == '') {
          callback(new Error(this.$t('setting.changePhone.areaErr')))
        } else if (value === '') {
          callback(new Error(this.$t('setting.changePhone.phoneInput')))
        } else if (!patrn.exec(value)) {
          callback(new Error(this.$t('setting.changePhone.phoneErr')))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      form: {
        newPhone: '',
        verCode: '',
        area: '+86'
      },
      formLabelWidth: '0',
      labelPosition: 'top',
      loading: false,
      cancel: false,
      rules: {
        newPhone: [
          { validator: checkNewPhone, trigger: 'change' }
        ],
        verCode: [
          { validator: checkVerCode, trigger: 'change' }
        ]
      },
      ToolTip: this.$t('setting.changePhone.sendVerTip'),
      countdown: 60,
      countStyle: '',
      isEnter: false,
      h4Show: true,
      subWrapShow: false,
      newPhoneShow: false,
      showPhoneNum: '',
      activeName: 'phone',
      oldTip: this.$t('changeEmail.oldTip', [this.params.email])
    }
  },
  computed: {
    ...mapGetters([
      'getClientProfile'
    ])
  },
  // mounted () {
  //   this.showPhoneNum = this.params
  //   this.params = this.params.substring(0, 2) == 86 ? this.params.substring(2) : this.params.substring(3);
  // },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        this.NotClickable()
        let areaNum = this.form.area.substring(1)
        let params = {
          name: this.getClientProfile.userInfo.chineseName || '',
          phoneNumber: this.newPhoneShow ? areaNum + this.form.newPhone : this.params.changePhoneNum,
          subject: this.$store.state.user.profile.sub,
          source: 'clientPortal'
        }
        let formVerCode = this.form.verCode
        let phoneKey = this.newPhoneShow ? params.phoneNumber : this.params.changePhoneNumShow
        let verCode = Cookies.get('phone_number' + phoneKey)
        if (valid) {
          if (this.activeName === 'email' && !this.newPhoneShow) {
            await this.verifyEmailCode() && this.validateVerCodeRequest()
          } else if (verCode == formVerCode) {
            console.log(params)
            this.newPhoneShow ? this.updatePhoneNumRequest(params) : this.validateVerCodeRequest(params)
          } else {
            this.clickable()
            console.log('验证码过期')
            this.$message.error(this.$t('setting.changePhone.verCodeFail'))
          }
        } else {
          this.clickable()
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName = 'form') { // 给默认值,处理doalog组件close事件默认执行重置方法
      this.countdown = 0
      this.$refs[formName].resetFields()
      this.h4Show = true
      this.subWrapShow = false
      this.newPhoneShow = false
      this.$emit('closeFun', false)
    },
    async validateVerCodeRequest (params) {
      this.h4Show = false
      this.subWrapShow = true
      this.newPhoneShow = true
      this.countdown = 0
      this.countStyle = ''
      this.clickable()
      this.$refs['form'].resetFields()
    },
    async updatePhoneNumRequest (params) {
      this.$api.updatePhoneNum(params).then(result => {
        console.log('updatePhone', result)
        if (Number(result.code) === 200) {
          console.log(200)
          this.$message({
            message: this.$t('setting.changePhone.success'),
            type: 'success'
          })
          // 退出登录
          const oAuth = new SecurityService()
          oAuth.signOut()
          // store.commit('setUser', null)
          // 提示修改手机号成功，退出重新登录
        } else {
          this.clickable()
          this.countdown = 0
          console.log('!200')
          let status = result.code
          this.$message.error(this.$t('setting.' + status))
        }
      }).catch(error => {
        this.clickable()
        console.log(error)
        this.countdown = 0
        if (error.code === 500) {
          this.$message.error(this.$t('setting.setPassword.resetPhoneFail'))
        } else {
          let msg = this.$t(`setting.changePhone[${error.code}]`) ? this.$t(`setting.changePhone[${error.code}]`) : this.$t('setting.changePhone.resetPhoneFail')
          this.$message.error(msg)
        }
      })
    },
    // async updatePhoneNumRequest (params) {
    //   // 查询该手机号是否被注册过
    //   this.$api.getUserByShowType(params).then(result => {
    //     if (result.code == 200 && Object.keys(result.data) == 0) {
    //       // 未注册更改手机号
    //       this.$api.updatePhoneNum(params).then(result => {
    //         console.log('updatePhone', result)
    //         if (Number(result.code) === 200) {
    //           console.log(200)
    //           this.$message({
    //             message: this.$t('setting.changePhone.success'),
    //             type: 'success'
    //           })
    //           // 退出登录
    //           const oAuth = new SecurityService()
    //           oAuth.signOut()
    //           // store.commit('setUser', null)
    //           // 提示修改手机号成功，退出重新登录
    //         } else {
    //           this.clickable()
    //           console.log('!200')
    //           let status = result.code
    //           this.$message.error(this.$t('setting.' + status))
    //         }
    //       }).catch(error => {
    //         this.clickable()
    //         console.log(error)
    //         this.$message.error(this.$t('setting.setPassword.fail'))
    //       })
    //     } else {
    //       this.$message.error(this.$t('setting.changePhone.registered'))
    //       this.countdown = 0
    //       this.clickable()
    //     }
    //   })
    // },
    NotClickable () {
      this.loading = true
      this.cancel = true
    },
    clickable () {
      this.loading = false
      this.cancel = false
    },
    async getVerificationCode () {
      if (this.activeName === 'email' && !this.newPhoneShow) {
        this.countdown = 60
        this.countStyle = { 'pointer-events': 'none' }
        this.countDown()
        this.sendEmailVerificationCode()
      } else {
        if (this.newPhoneShow) {
          let patrn = /^1[3|4|5|7|8][0-9]\d{4,8}$/
          if (this.form.area == '') {
            this.$refs.form.validateField('newPhone')
            return false
          } else if (this.form.newPhone === '') {
            this.$refs.form.validateField('newPhone')
            return false
          } else if (!patrn.exec(this.form.newPhone)) {
            this.$refs.form.validateField('newPhone')
            return false
          }
        }
        this.countdown = 60
        this.countStyle = { 'pointer-events': 'none' }
        this.countDown()
        // 请求后端接口发送验证码
        this.verificationCode()
      }
    },
    // 验证码倒计时
    countDown () {
      var vm = this
      if (vm.countdown == 0) {
        vm.countStyle = ''
        vm.ToolTip = this.$t('setting.changePhone.sendVerTip')
        vm.countdown = 60
        return
      } else {
        vm.ToolTip = vm.countdown + 's'
        vm.countdown--
      }
      setTimeout(function () { vm.countDown() }, 1000)
    },
    async verificationCode () {
      try {
        let phoneKey = this.newPhoneShow ? this.form.area.substring(1) + this.form.newPhone : this.params.changePhoneNumShow
        let phoneNumber = this.newPhoneShow ? this.form.newPhone : this.params.changePhoneNum
        // this.$exodusApi.getExodusVerCode(param).then(result => {
        //   if (result.code == 200) {
        //     Cookies.set('phone_number' + phoneKey, result.data.verifyCode, { expires: 0.05 })
        //   }
        // })
        let res = await this.$api.getVCode(phoneNumber)
        Cookies.set('phone_number' + phoneKey, res.vcode, { expires: 0.05 })
      } catch (error) {
        let errMessage = ''
        if (error.code) {
          switch (error.code) {
            case '5008':
              errMessage = this.$t('setting.5008')
              break
            default:
              errMessage = this.$t('setting.40000')
              break
          }
          return this.$message.error(errMessage)
        } else {
          errMessage = this.$t('setting.40000')
          return this.$message.error(errMessage)
        }
      }
    },
    sendEmailVerificationCode () {
      let data = {
        email: this.params.email
      }
      return this.$api.sendEmailCode({
        data: data,
        type: 'old'
      }).then(result => {
        let tip = ``
        if (!result.data.status) { // 验证码生成失败或者邮件发送失败
          tip = result.data.msg
        } else {
          let href = this.getEmailService(data.email)
          if (!href) {
            tip = this.$t('changeEmail.showTip1', [data.email])
          } else {
            tip = this.$t('changeEmail.showTip2', [data.email, href])
          }
        }
        this.oldTip = tip
        return true
      })
    },
    getEmailService (email) {
      let hash = {
        'qq.com': 'http://mail.qq.com',
        'gmail.com': 'http://mail.google.com',
        'sina.com': 'http://mail.sina.com.cn',
        '163.com': 'http://mail.163.com',
        '126.com': 'http://mail.126.com',
        'yeah.net': 'http://www.yeah.net/',
        'sohu.com': 'http://mail.sohu.com/',
        'tom.com': 'http://mail.tom.com/',
        'sogou.com': 'http://mail.sogou.com/',
        '139.com': 'http://mail.10086.cn/',
        'hotmail.com': 'http://www.hotmail.com',
        'live.com': 'http://login.live.com/',
        'live.cn': 'http://login.live.cn/',
        'live.com.cn': 'http://login.live.com.cn',
        '189.com': 'http://webmail16.189.cn/webmail/',
        'yahoo.com.cn': 'http://mail.cn.yahoo.com/',
        'yahoo.cn': 'http://mail.cn.yahoo.com/',
        'eyou.com': 'http://www.eyou.com/',
        '21cn.com': 'http://mail.21cn.com/',
        '188.com': 'http://www.188.com/',
        'foxmail.coom': 'http://www.foxmail.com'
      }
      let add = email.slice(email.indexOf('@') + 1)
      for (let key in hash) {
        if (key === add) {
          return hash[key]
        }
      }
      return false
    },
    async verifyEmailCode (formName) {
      let data = {
        email: this.params.email,
        code: this.form.verCode
      }
      let type = 'old'
      this.NotClickable()
      let result = await this.$api.verifyEmailCode({ data: data, type: type })
      this.clickable()

      if (result.data.status === 1) {
        this.openMessage('error', this.$t('changeEmail.error.1'))
        return false
      }
      if (result.data.status === 0) {
        this.openMessage('error', this.$t('changeEmail.error.0'))
        return false
      }
      if (result.data.status === 3) {
        console.log(result.data.msg)
        return false
      }
      return true
    },
    selectVerifyType (tab, event) {
      this.$refs['form'].resetFields()
      this.newPhoneShow = false
      this.oldTip = this.$t('changeEmail.oldTip', [this.params.email])
    }
  }

}
</script>
<style lang="scss">
.page-change-phone {
  .form-password {
    margin: 0rem 2.5rem;
    padding-bottom: 0rem;
  }
  h2 {
    line-height: 41px;
    font-size: 22px;
    text-align: center;
    font-family: PingFangTC-Regular;
    margin-top: -1rem;
    font-family: Muli-Bold;
    color: #24282d;
    letter-spacing: 0.27px;
  }
  h4 {
    text-align: center;
    width: 100%;
    margin: auto;
  }
  .el-form {
    margin-top: 2.5rem;
  }
  .submit-button,
  .cancel-button {
    width: 100%;
    height: 100%;
    margin: auto;
    line-height: 20px;
    color: black !important;
    border: 1px solid rgba(255, 255, 255, 0);
  }
  .footer-wrap {
    margin-top: 50px;
  }
  .cancel-button {
    background: white !important;
    border: 1px solid black !important;
  }
  .dialog-footer {
    width: 100%;
    height: 3rem;
    margin: 1rem auto;
  }
  .dialog-footer:nth-of-type(1) {
    margin-top: 3rem;
  }
  .el-form-item__label {
    font-family: Muli-Regular !important;
    font-size: 11px !important;
    color: #7d7d7d !important;
    letter-spacing: 0.13px !important;
  }
  .el-input {
    text-align: center;
  }
  .el-input__inner {
    border: 1px solid #e0e0e0 !important;
    border-radius: 5px !important;
    font-family: Muli-Bold !important;
    font-size: 14px !important;
    color: #24282d !important;
    letter-spacing: 0 !important;
    width: 100%;
  }
  .el-input--suffix {
    width: 100%;
  }
  .el-form-item__content {
    text-align: center;
    width: 100% !important;
  }
  .append-text {
    opacity: 0.9;
    color: rgba(254, 192, 0, 1);
    font-size: 14px;
    text-align: center;
    font-family: Muli-Regular;
  }
  .sendSuccess {
    text-align: center;
    color: rgba(254, 192, 0, 1);
  }
  .isSend {
    border: none !important;
  }
  //  .area-select .el-input{
  //   width: 100px;
  // }
  // .area-select .el-input--suffix input {
  //   width: 100%;
  // }
  .new-phone {
    .el-input__inner {
      width: 100%;
    }
  }
  .el-form-item__content {
    width: 250px;
    margin: auto;
  }
  .el-input-group__prepend {
    background-color: #fff;
  }
}
</style>
